export const GRID_PAGE_NO_BACK_SWIPE = "grid-page-no-back-swipe";

export const COLUMN_TYPES = {
  DateField: "dateColumn",
  InputColumn: "text",
  LinkedRecordField: "text",
  NumericField: "numberColumn",
  SingleLineField: "text",
  SingleSelectField: "singleSelect",
  CheckBoxField: "checkbox",
  CurrencyField: "numberColumn",
};

export const DEALTABLE_COLUMN_TYPES = {
  CheckBoxField: "CHECKBOX_FIELD",
  CurrencyField: "CURRENCY_FIELD",
  DateField: "DATE_FIELD",
  InputColumn: "TEXT_FIELD",
  LinkedRecordField: "TEXT_FIELD",
  NumericField: "NUMBER_FIELD",
  ObjectField: "OBJECT_FIELD",
  PercentField: "PERCENTAGE_FIELD",
  SingleLineField: "TEXT_FIELD",
  SingleSelectField: "SINGLE_SELECT_FIELD",
};

export const CELL_TYPES = [
  {
    type: "Single Line Field",
  },
  {
    type: "Single Select Field",
  },
];

export const DEALTABLE_COLUMNS = {
  ADDITIONAL_DISCOUNT_PERCENT: "addl_discount_percent",
  BASE_PRICE: "base_price",
  BILLING_FREQUENCY: "billing_frequency",
  BILLING_FREQUENCY_EDITABLE: "billing_frequency_editable",
  BUNDLE_QUANTITY: "bundle_quantity",
  CHARGE_FREQUENCY: "charge_frequency",
  CHARGE_TYPE: "charge_type",
  COMPUTED_CATEGORY: "computed_category",
  COMPUTED_FAMILY: "computed_family",
  CONFIG_TYPE: "config_type",
  DEFAULT_QUANTITY: "default_quantity",
  DISCOUNTED_PRICE: "discounted_price",
  DISCOUNT_AMT: "discount_amt",
  DISCOUNT_TYPE: "discount_type",
  DISCOUNT_VALUE: "discount_value",
  DISC_PERCENT: "disc_percent",
  DT_GROUP_ID: "dt_group_id",
  END_DATE: "end_date",
  EXT_BASE_PRICE: "ext_base_price",
  IS_RENEWABLE: "is_renewable",
  IS_QTY_EDITABLE: "is_qty_editable",
  IS_SELLINGTERM_EDITABLE: "is_sellingterm_editable",
  MAX_USAGE: "max_usage",
  MAX_USAGE_UOM: "max_usage_uom",
  MIN_QTY: "min_quantity",
  MIN_SELLING_TERM: "min_selling_term",
  NET_PRICE: "net_price",
  OVERALL_DISCOUNT_PERCENT: "overall_discount_percent",
  PRICE: "price", // Acts as baseprice
  PRICELIST_ITEM: "pricelist_item",
  PRICE_METHOD: "price_method",
  PRODUCT: "product",
  PRODUCT_CODE: "product_code",
  PRODUCT_DESC: "product_desc",
  PRODUCT_NAME: "product_name",
  PTYPE: "ptype",
  QUANTITY: "quantity",
  QUANTITY_EDITABLE: "is_qty_editable",
  QUANTITY_UOM: "quantity_uom",
  RECURRING_PERIOD: "recurring_period",
  REMARKS: "remarks",
  SELLING_TERM: "selling_term",
  SKU: "sku",
  SKU_QUANTITY: "sku_quantity",
  SKU_QUANTITY_EDITABLE: "sku_quantity_editable",
  START_DATE: "start_date",
  UOM: "uom",
};

export const GRID_PAGE_TYPE = {
  DEALTABLE: "DealTable",
  PRODUCTS: "Products",
  PRICELIST: "Pricelist",
};

export const PRODUCTS_COLUMNS = {
  ACTIVE: "active",
  ATTRIBUTE_GROUPS: "attribute_groups",
  BUNDLES: "bundles",
  CATEGORY: "category",
  CATEGORY_NAME: "category_name",
  CODE: "code",
  CONFIG_TYPE: "config_type",
  DESC: "desc",
  FAMILY: "family",
  FAMILY_NAME: "family_name",
  ID: "id",
  IS_BUNDLE: "is_bundle",
  IS_OPTION: "is_option",
  NAME: "name",
  SKU: "sku",
  TYPE: "ptype",
};

export const PRICEBOOK_COLUMNS = {
  ACTIVE: "active",
  BILLING_FREQUENCY: "billing_frequency",
  CHARGE_CRITERIA: "charge_criteria",
  CHARGE_FREQUENCY: "charge_frequency",
  CHARGE_TYPE: "charge_type",
  COST_PRICE: "cost_price",
  DEFAULT_QTY: "default_qty",
  DESC: "desc",
  EFFECTIVE_DATE: "effective_date",
  EXPIRY_DATE: "expiry_date",
  ID: "id",
  IS_RENEWABLE: "is_renewable",
  LIST_PRICE: "price",
  MAX_PRICE: "max_price",
  MAX_USAGE: "max_usage",
  MAX_USAGE_UOM: "max_usage_uom",
  MIN_PRICE: "min_price",
  MIN_QTY: "min_qty",
  PRICE: "price",
  PRICELISTITEMENTRIES: "pricelistitementries",
  PRICE_METHOD: "price_method",
  PRODUCT: "product",
  PRODUCT_CODE: "product_code",
  PRODUCT_CONFIG_TYPE: "product_config_type",
  PRODUCT_DESC: "product_desc",
  PRODUCT_NAME: "product_name",
  PRODUCT_TYPE: "product_type",
  QTY_EDITABLE: "qty_editable",
  QUANTITY_UOM: "quantity_uom",
  RECURRING_PERIOD: "recurring_period",
  REMARKS: "remarks",
  SCALE: "scale",
  SELLINGTERM_EDITABLE: "sellingterm_editable",
  SELLING_TERM: "selling_term",
  SKU: "sku",
  UOM: "uom",
};

export const PRODUCT_MAPS_DEALTABLE = {
  base_price: "list_price",
  charge_type: "charge_type",
  price_method: "price_method",
  pricelist_item: "id",
  product: "product.id",
  product_code: "product.code",
  product_desc: "product.description",
  product_name: "product.name",
  quantity: "default_qty",
  sku: "sku",
  uom: "uom",
};

export const PAGE_TO_APPVIEW_MAP = {
  Pricelist: "PricelistItemsView",
  DealTable: "DealTableView",
};

export const GRID_ADMIN_ROLES = ["Admin", "RevvAdmin"];

export const PRICING_METHODS = {
  BUNDLE_PRICING: "Bundle Pricing",
  FLAT_PRICE: "Flat Price",
  NON_LINEAR: "Non Linear",
  PERCENTAGE_OF_TOTAL: "Percentage of Total",
  STEP_TIER_PRICING: "Step-Tier Pricing",
  TIER_PRICING: "Tier Pricing",
  VOLUME_PRICING: "Volume Pricing",
  DIY_PRICING: "DIY Pricing",
};

export const PRICING_METHODS_LABELS = {
  "Bundle Pricing": "Bundle Pricing",
  "DIY Pricing": "DIY Pricing",
  "Flat Price": "Flat Price",
  "List Price": "Flat Price",
  "Non Linear": "Non Linear",
  "Percentage of Total": "Percentage of Total",
  "Step-Tier Pricing": "Stair-Step Pricing",
  "Tier Pricing": "Tier Pricing",
  "Volume Pricing": "Volume Pricing",
};

export const DEALTABLE_GROUP_LIST = [
  // {
  //   name: "Category",
  //   alias: "computed_category",
  //   icon: "tags",
  // },
  {
    name: "Charge Type",
    alias: "charge_type",
    icon: "file-invoice-dollar",
  },
  {
    name: "Family",
    alias: "computed_family",
    icon: "flag-alt",
  },
  {
    name: "Product Type",
    alias: "ptype",
    icon: "bookmark",
  },
];

export const RECURRING_PERIOD = {
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  HALF_YEARLY: "Half Yearly",
  YEARLY: "Yearly",
};

export const RECURRENCE = {
  Daily: 0,
  Weekly: 1,
  Monthly: 2,
  Quarterly: 3,
  "Half Yearly": 4,
  Yearly: 5,
};

export const CONVERSION_FACTORS = [
  [1, 7, 30, 90, 180, 365], // Daily
  [1, 1, 4, 13, 26, 52], // Weekly
  [1, 1, 1, 3, 6, 12], // Monthly
  [1, 1, 1, 1, 2, 4], // Quarterly
  [1, 1, 1, 1, 1, 2], // Half Yearly
  [1, 1, 1, 1, 1, 1], // Yearly
];

export const CHARGE_TYPE_METHODS = {
  ONE_TIME: "One Time",
  RECURRING: "Recurring",
  RECURRING_USAGE: "Recurring Usage",
  USAGE_ONE_TIME: "Usage One-Time",
};

export const NUMERICAL_ROUNDING = [
  {
    alias: "decimal",
    label: "Round up to one decimal",
    example: "(for eg: 123.168 => 123.2)",
  },
  {
    alias: "unit",
    label: "Round up to nearest whole number",
    example: "(for eg: 123.168 => 124)",
  },
  {
    alias: "tens",
    label: "Round up to tens",
    example: "(for eg: 11 => 20)",
  },
];



// WEBPACK FOOTER //
// ./src/constants/agGrid.js